<template>
  <div id="app">
    <zhezhao v-show="showPro" @hideZhe="showPro=false"></zhezhao>
    <Nav @clickPro="togglePro()" :upD="showPro" :projectName="projectName" :user="ProjectList" v-on:lot="logout"></Nav>
    <keep-alive>
    <router-view/>
    </keep-alive>
    <transition name="slide">
      <div class="selectProject-cotent1" v-show="showPro"><selectProject :Projects="ProjectList" @clickProDet="selectPro" :searchText="$store.state.module1.isChina?'请输入项目名称':'enter project name'"></selectProject></div>
    </transition>
  </div>
</template>

<script>
import selectProject from './components/Project/Project.vue'
import zhezhao from './components/zhezhao/zhezhao.vue'
import Nav from './components/nav/nav.vue'
import { Mixin } from './mixins/index.js'
import { stringTime, requestData } from './assets/js/commont.js'
export default {
  components: {
    Nav,
    selectProject,
    zhezhao
  },
  mixins: [Mixin],
  provide () {
    return {
      reToken: this.reToken
    }
  },
  data () {
    return {
      showPro: false
    }
  },
  methods: {
    // 退出登录
    logout () {
      window.localStorage.clear()
      this.$router.push('/login')
      window.location.reload()
    },
    // 切换项目
    togglePro () {
      if (this.ProjectList) {
        this.showPro = !this.showPro
      }
    },
    // 第二步选择项目
    selectPro (id, city) {
      if (window.localStorage.getItem('token')) {
        this.showPro = false
        window.localStorage.setItem('proId', id)
        window.localStorage.setItem('proCity', city)
        this.$store.commit('setProjectName', id)
        this.$router.replace('/projectAreaDetail' + id)
      } else {
        this.$message({
          message: this.$store.state.module1.isChina ? '请先登录' : 'log on first',
          type: 'warning'
        })
      }
    },
    // 无限加载
    loadMore () {
      this.getP()
    },
    // 获取项目列表函数 --------------------------- 接口
    getP () {
      if (window.localStorage.getItem('token')) {
        var time = stringTime(this.$myTime())
        var data = {
          account: window.localStorage.getItem('account'),
          is_all: 1,
          token: window.localStorage.getItem('token'),
          ts: time
        }
        this.getProjectList(requestData(data))
      }
    }
  },
  created () {
    if (window.localStorage.getItem('showDb')) {
      this.$store.commit('setDb', true)
    }
    if (window.localStorage.getItem('isAir')) {
      this.$store.commit('setAir', true)
    }
    // 第一步先获取项目列表
    if (window.localStorage.getItem('token')) {
      this.getP()
    }
    if (window.localStorage.getItem('lang')) {
      this.$store.commit('setLang', JSON.parse(window.localStorage.getItem('lang')))
    }
    // 第一遍不管
    if (window.localStorage.getItem('unit')) {
      var u = JSON.parse(window.localStorage.getItem('unit'))
      var item = [
        {
          name: 'PM2.5',
          unit: u.pm25
        },
        {
          name: 'TVOC',
          unit: u.tvoc
        },
        {
          name: 'HCHO',
          unit: u.hcho
        },
        {
          name: 'PM10',
          unit: u.pm10
        }
      ]
      this.$store.commit('setU', item)
    } else {
      window.localStorage.setItem('unit', JSON.stringify({
        pm25: this.U[0].unit,
        tvoc: this.U[1].unit,
        hcho: this.U[2].unit,
        pm10: this.U[3].unit
      }))
    }
  },
  watch: {
    // 获取项目列表后
    ProjectList () {
      this.$nextTick(() => {
        if (window.localStorage.getItem('proId')) {
          this.$store.commit('setProjectName', window.localStorage.getItem('proId'))
        }
      })
    }
  },
  mounted () {

  }
}
</script>

<style lang="less">
html,body,#app{
  width:100%;
  height:100%;
}
#app {
  text-align: center;
  background: #F5F6FA;
  color:#1D2D4E;
  font-size:0.16rem;
  position:relative;
  overflow:hidden;
  margin:0 auto;
}
.selectProject-cotent1{
  position:absolute;
  top:0.8rem;
  width:4rem;
  max-height:8rem;
  overflow:auto;
  left:0.24rem;
  z-index:101;
   border-radius:0.16rem;
   margin-bottom:0.2rem;
}
</style>
